import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const DisconnectedErrorModal = ({show_condition}) => {
  return (
    <Modal
      show={show_condition}
      >
      <div className='panel panel-danger'>
        <div className='panel-heading thin-modal-heading' style={{color : 'white'}}>
          <h4>Disconnected!</h4>
        </div>
        <Modal.Body>
          You have been disconnected from the server. Refresh the page or any future edits made will not be saved.
        </Modal.Body>
      </div>
    </Modal>
  )
}

export default DisconnectedErrorModal;



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/disconnected-error-modal.js